<template>
  <ancestryline-modal title="dataTable.protocol.filters" id="modal-protocol-filters" :close="true" @close="close" :loading="false">
    <form @submit.prevent="applyFilter" @keydown.enter.prevent="applyFilter">
      <card :header="$t('forms.protocol.card-information')" class="p-col-12" >
        <coff-input-text v-model="filters.code" label="forms.protocol.code" class="p-col-12 p-md-6 p-lg-6" @keydown.enter.prevent="applyFilter"/>
        <coff-input-text v-model="filters.name" label="forms.protocol.name" class="p-col-12 p-md-6 p-lg-6" @keydown.enter.prevent="applyFilter"/>
        <coff-input-auto-complete v-model="client" label="forms.protocol.client" class="p-col-12 p-md-6 p-lg-6" :itens="clients" field="name" :func-suggestions="searchClient" @keydown.enter.prevent="applyFilter"/>
        <coff-input-auto-complete v-model="typeService" label="forms.protocol.type-service" class="p-col-12 p-md-6 p-lg-6" :itens="typeServices" field="name" :func-suggestions="searchTypeService" @keydown.enter.prevent="applyFilter"/>
        <coff-input-text v-model="filters.family_name" label="forms.protocol.family-name" class="p-col-12 p-md-6 p-lg-6" @keydown.enter.prevent="applyFilter"/>
        <coff-input-select v-model="filters.status" label="dataTable.protocol.columns.status" class="p-col-12 p-md-6 p-lg-6" :options="statusList" option-value="id"/>
        <coff-input-select v-model="filters.stage_id" label="forms.protocol.stage" class="p-col-12 p-md-6 p-lg-6" :options="stages" option-value="id"/>
        <coff-input-select v-model="filters.current_user" label="forms.protocol.current-user" class="p-col-12 p-md-6 p-lg-6" :options="users" option-value="id"/>
        <CoffInputRadio v-model="filters.budget" @update="forceUpdateField('budget', $event)" :options="budgetOptions" class="p-col-12 p-md-12 p-lg-12"/>
      </card>

    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.clear')" @click.prevent="clearFilter" class="p-button-secondary p-mr-auto"/>
        <Button :label="$t('btn.filter')" @click.prevent="applyFilter" class="float-right p-button-primary"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import ClientBusiness from "@/business/ClientBusiness";
import StageBusiness from "@/business/StageBusiness";
import UserBusiness from "@/business/UserBusiness";
import TypeServiceBusiness from "@/business/TypeServiceBusiness";
import {STATUS_PROTOCOL} from "@/constants/StatusProtocol";

export default {
  name: "ModalProtocolFilter",

  props: {
    showTypeProtocolFilter: {type: Boolean,  default: false},
    filters: {},
  },

  data() {
    return {
      clients: [],
      typeServices: [],
      typeService: null,
      client: null,
      stages: [],
      users: [],
      statusList: STATUS_PROTOCOL,
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
      budgetOptions: [
        {value: true, label: 'dataTable.protocol.columns.budget'},
        {value: false, label: 'dataTable.protocol.columns.protocol'},
        {value: null, label: 'btn.all'}
      ]
    }
  },

  async mounted(){
    this.stages = await StageBusiness.getAll();
    this.users = await UserBusiness.getAll();
    if(this.filters.person_id){
      this.client = await ClientBusiness.getById(this.filters.person_id);
    }
    if(this.filters.type_service_id){
      this.typeService = await TypeServiceBusiness.getById(this.filters.type_service_id);
    }
  },

  watch: {
    typeService(value){
      this.filters.type_service_id = value ? value.id : null;
    },
    client(value){
      this.filters.person_id = value ? value.id : null;
    },
  },

  methods:{

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

    async searchTypeService(name){
      return await TypeServiceBusiness.search(name);
    },

    forceUpdateField(field, value){
      this.$set(this.filters, field, value);
    },

    close(){
      DialogService.closeModal();
    },

    clearFilter(){
      this.filters.name = null;
      this.filters.code = null;
      this.filters.family_name = null;
      this.filters.person_id = null;
      this.filters.status = null;
      this.filters.budget = null;
      this.filters.stage_id = null;
      this.filters.current_user = null;
      this.filters.type_service_id = null;
      this.typeService = null;
      this.client = null;
    },

    applyFilter(){
      DialogService.closeModal(this.filters);
    },

  },

}
</script>

<style scoped>

</style>